// OTE spotové ceny — denní křivka.
// Reálná data 12. 5. 2024 (neděle, rekordní propad cen v ČR).
// Zdroj: OTE, a.s. tisková zpráva 4. 9. 2024 — minimum −138,75 EUR/MWh.
// Hodnoty v Kč/MWh, kurz CZK/EUR ≈ 25, bez DPH a distribuce.

export const oteHistorical = {
  date: '2024-05-12',
  label: 'mock.ote.historicalLabel',
  description: 'Rekordní propad cen kvůli FVE přebytku — minimum −138,75 EUR/MWh.',
  hourly: [
    { hour: '00', price: -250 }, { hour: '01', price: -380 },
    { hour: '02', price: -420 }, { hour: '03', price: -510 },
    { hour: '04', price: -480 }, { hour: '05', price: -290 },
    { hour: '06', price: -120 }, { hour: '07', price: 80 },
    { hour: '08', price: 320 }, { hour: '09', price: 150 },
    { hour: '10', price: -650 }, { hour: '11', price: -1850 },
    { hour: '12', price: -3470 }, { hour: '13', price: -2900 },
    { hour: '14', price: -1400 }, { hour: '15', price: -750 },
    { hour: '16', price: -250 }, { hour: '17', price: 480 },
    { hour: '18', price: 1280 }, { hour: '19', price: 1620 },
    { hour: '20', price: 980 }, { hour: '21', price: 540 },
    { hour: '22', price: 180 }, { hour: '23', price: -50 },
  ],
};

// Typický pracovní den, jaro 2026 — referenční křivka pro plánování.
export const oteTypicalDay = {
  date: 'typical',
  label: 'mock.ote.typicalLabel',
  description: 'Modelová křivka — pondělí–pátek, jaro 2026.',
  hourly: [
    { hour: '00', price: 950 }, { hour: '01', price: 880 },
    { hour: '02', price: 820 }, { hour: '03', price: 800 },
    { hour: '04', price: 850 }, { hour: '05', price: 920 },
    { hour: '06', price: 1100 }, { hour: '07', price: 1450 },
    { hour: '08', price: 1700 }, { hour: '09', price: 1500 },
    { hour: '10', price: 800 }, { hour: '11', price: 200 },
    { hour: '12', price: -350 }, { hour: '13', price: 100 },
    { hour: '14', price: 1400 }, { hour: '15', price: 2050 },
    { hour: '16', price: 2200 }, { hour: '17', price: 2400 },
    { hour: '18', price: 2350 }, { hour: '19', price: 2150 },
    { hour: '20', price: 1700 }, { hour: '21', price: 1350 },
    { hour: '22', price: 1100 }, { hour: '23', price: 1000 },
  ],
};

// Klasifikace pásma podle ceny — pro pozadí slotu a vyhodnocení úspory.
export function tariffBand(priceCzkPerMWh) {
  if (priceCzkPerMWh < 0) return 'negative';
  if (priceCzkPerMWh < 1300) return 'offpeak';
  if (priceCzkPerMWh < 1900) return 'standard';
  return 'peak';
}

// Pro slot.shift mapování na hodinový rozsah a průměrnou cenu.
export const shiftHours = {
  night: { from: 22, to: 6, label: '22:00–06:00' },
  morning: { from: 6, to: 14, label: '06:00–14:00' },
  midday: { from: 10, to: 14, label: '10:00–14:00 (FVE okno)' },
  afternoon: { from: 14, to: 22, label: '14:00–22:00' },
};
